class Dialectic {
  constructor(concept = "", negation = "", synthesis = "") {
    this.concept = concept;
    this.negation = negation;
    this.synthesis = synthesis;
  }
}

export default Dialectic;
